<template>
  <div class="flex justify-center">
    <div class="inline-flex justify-center mx-auto mb-4 p-4 border-4 border-success-600 rounded-full">
      <UIcon
        name="i-lucide-thumbs-up"
        class="w-[75px] h-[75px] text-success-600"
      />
    </div>
  </div>
</template>
